import React, { useState } from "react";

const OtherTravellers = () => {
  const [travellers, setTravellers] = useState([]);

  const handleAddTraveller = () => {
    const newTraveller = {
      firstName: "",
      lastName: "",
      dateOfBirth: "",
    };
    setTravellers([...travellers, newTraveller]);
  };

  const handleTravellerChange = (index, e) => {
    const { name, value } = e.target;
    const newTravellers = [...travellers];
    newTravellers[index][name] = value;
    setTravellers(newTravellers);
  };

  const handleRemoveTraveller = (index) => {
    const newTravellers = [...travellers];
    newTravellers.splice(index, 1);
    setTravellers(newTravellers);
  };

  return (
    <div className="p-6">
      <h2 className="text-white text-lg font-medium mb-4">Other Travellers</h2>
      {travellers.map((traveller, index) => (
        <div key={index} className="mb-4">
          <h3 className="text-lg font-medium mb-2">
            Traveller {index + 1} Details
          </h3>
          <div className="flex flex-col">
            <label htmlFor={`firstName-${index}`} className="mb-2">
              First Name(s)*
            </label>
            <input
              type="text"
              id={`firstName-${index}`}
              name="firstName"
              value={traveller.firstName}
              onChange={(e) => handleTravellerChange(index, e)}
              className="border border-gray-400 rounded px-4 py-2 mb-2"
            />
            <label htmlFor={`lastName-${index}`} className="mb-2">
              Last Name(s)*
            </label>
            <input
              type="text"
              id={`lastName-${index}`}
              name="lastName"
              value={traveller.lastName}
              onChange={(e) => handleTravellerChange(index, e)}
              className="border border-gray-400 rounded px-4 py-2 mb-2"
            />
            <label htmlFor={`dateOfBirth-${index}`} className="mb-2">
              Date of Birth*
            </label>
            <div className="flex">
              <input
                type="number"
                id={`dateOfBirth-day-${index}`}
                name="dateOfBirthDay"
                placeholder="DD"
                value={traveller.dateOfBirthDay}
                onChange={(e) => handleTravellerChange(index, e)}
                className="border border-gray-400 rounded px-4 py-2 mb-2 mr-2 w-1/4"
              />
              <input
                type="text"
                id={`dateOfBirth-month-${index}`}
                name="dateOfBirthMonth"
                placeholder="Month"
                value={traveller.dateOfBirthMonth}
                onChange={(e) => handleTravellerChange(index, e)}
                className="border border-gray-400 rounded px-4 py-2 mb-2 mr-2 w-1/2"
              />
              <input
                type="number"
                id={`dateOfBirth-year-${index}`}
                name="dateOfBirthYear"
                placeholder="YYYY"
                value={traveller.dateOfBirthYear}
                onChange={(e) => handleTravellerChange(index, e)}
                className="border border-gray-400 rounded px-4 py-2 mb-2 w-1/4"
                />
                </div>
                <p className="text-gray-500 text-sm mb-2">
                It’s important to enter a correct date of birth, as these details can be used for booking or ticketing purposes
                </p>
                {travellers.length > 1 && (
                <button
                type="button"
                className="text-red-500 text-sm mb-2 cursor-pointer"
                onClick={() => handleRemoveTraveller(index)}
                >
                Remove Traveller
                </button>
                )}
                </div>
                </div>
                ))}
                <button
                     type="button"
                     className="text-white bg-black hover:scale-[1.05] transition-all px-4 py-2 rounded cursor-pointer"
                     onClick={handleAddTraveller}
                   >
                Add new traveller
                </button>
                <p className="text-gray-500 text-sm mt-4">
                Please get permission from your fellow travellers before entering their personal details.
                </p>
                </div>
                );
                };
                
                export default OtherTravellers;
